module.exports = __webpack_public_path__ + "img/T6-C-xs_4.f1ae0874.png";